import { Card, Typography, Skeleton, Stack } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

function RegulationFeedItemSkeleton() {
  return (
    <Card sx={{ padding: 2, paddingBottom: 1 }} variant='outlined'>
      <Typography variant='h5'>
        <Skeleton />
      </Typography>
      <Typography variant='body2'>
        <Skeleton />
      </Typography>
    </Card>
  );
}

interface RegulationFeedItemProps {
  readonly count?: number;
}

export default function RegulationFeedSkeleton({
  count = 10,
}: RegulationFeedItemProps) {
  const components = [...Array(count)].map(() => {
    const id = uuidv4();
    return (
      <RegulationFeedItemSkeleton key={'regulation-feed-item-skeleton-' + id} />
    );
  });

  return (
    <Stack
      useFlexGap
      sx={{
        gap: 2,
      }}
    >
      {components}
    </Stack>
  );
}
